import * as yup from 'yup';

export type ForgotPasswordData = {
  email: string;
};

export const validationSchema: yup.ObjectSchema<ForgotPasswordData> =
  yup.object({
    email: yup.string().email().required(),
  });

export type ForgotPasswordFormFields = yup.InferType<typeof validationSchema>;
